module.exports = __webpack_public_path__ + "static/media/temp-cload-center-right.af01ac0b.png";